import { Link } from "react-router-dom";
import React from "react";
import { AuthData } from "../auth/AuthWrapper";
import styles from "./Account.module.css"; // Import the CSS module
import profileImage from "../assets/catprofile.jpg";
import Card from "../components/structure/Card";

export const Account = () => {
  const { user, logout } = AuthData();

  return (
    <Card>
      <div className={styles.accountImageCircle}>
        <img src={profileImage} alt="profile" />
      </div>

      <h2>Hello, {user.name}!</h2>

      <div className={styles.accountStatsContainer}>
        <div className={styles.accountStatsBlock}>
          <div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="#9644C6"
              className="w-6 h-6"
            >
              <path
                fillRule="evenodd"
                d="M3 2.25a.75.75 0 01.75.75v.54l1.838-.46a9.75 9.75 0 016.725.738l.108.054a8.25 8.25 0 005.58.652l3.109-.732a.75.75 0 01.917.81 47.784 47.784 0 00.005 10.337.75.75 0 01-.574.812l-3.114.733a9.75 9.75 0 01-6.594-.77l-.108-.054a8.25 8.25 0 00-5.69-.625l-2.202.55V21a.75.75 0 01-1.5 0V3A.75.75 0 013 2.25z"
                clipRule="evenodd"
              />
            </svg>
          </div>
          <div>
            <p className={styles.stat}>27</p>
            <p>Quizzes Passed</p>
          </div>
        </div>

        <div className={styles.accountStatsBlock}>
          <div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="#9644C6"
              className="w-6 h-6"
            >
              <path
                fillRule="evenodd"
                d="M8.603 3.799A4.49 4.49 0 0112 2.25c1.357 0 2.573.6 3.397 1.549a4.49 4.49 0 013.498 1.307 4.491 4.491 0 011.307 3.497A4.49 4.49 0 0121.75 12a4.49 4.49 0 01-1.549 3.397 4.491 4.491 0 01-1.307 3.497 4.491 4.491 0 01-3.497 1.307A4.49 4.49 0 0112 21.75a4.49 4.49 0 01-3.397-1.549 4.49 4.49 0 01-3.498-1.306 4.491 4.491 0 01-1.307-3.498A4.49 4.49 0 012.25 12c0-1.357.6-2.573 1.549-3.397a4.49 4.49 0 011.307-3.497 4.49 4.49 0 013.497-1.307zm7.007 6.387a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.75-5.25z"
                clipRule="evenodd"
              />
            </svg>
          </div>
          <div>
            <p className={styles.stat}>200</p>
            <p>Quizzes Answered</p>
          </div>
        </div>
      </div>

      <div className={styles.accountLinksContainer}>
        <button className="buttonMisc">
          <Link to="/leaderboard">Leaderboard</Link>
        </button>
        <button className="buttonMisc">
          <Link to="/settings">Quiz Settings</Link>
        </button>

        <ul>
          <li className={styles.menuItem} onClick={logout}>
            <Link to="/">Logout</Link>
          </li>
        </ul>
      </div>
    </Card>
  );
};
